const binding = { modules: {}, dataActions: {} };

    (binding.modules['herbal-faqs'] = {
        c: () => require('partner/modules/herbal-faqs/herbal-faqs.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'herbal-faqs',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/herbal-faqs'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|herbal-faqs|herbal-faqs'] = {
                c: () => require('partner/modules/herbal-faqs/herbal-faqs.view.tsx'),
                cn: '__local__-__local__-herbal-faqs'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };